export default __webpack_public_path__ + "static/us_consumer_pa_modal_gift_2-d8223cb1caaffa4928f1198ee86499ac.png";